import Svg, { G, Path } from 'react-native-svg'

export const UpArrow = () => {
  return (
    <Svg width="16" height="16" viewBox="0 0 16 16">
      <G id="up-arrow" transform="translate(-11307 -11831)">
        <rect
          id="Rectangle_1948"
          data-name="Rectangle 1948"
          width="16"
          height="16"
          transform="translate(11307 11831)"
          fill="#fff"
          opacity="0"
        />
        <Path
          id="Path_1896"
          data-name="Path 1896"
          d="M12.234-10.828v-.023q0-.008-.016-.008a.069.069,0,0,0-.008-.031.069.069,0,0,1-.008-.031l-.008-.016a.069.069,0,0,1-.008-.031.032.032,0,0,0-.008-.023L12.172-11a.085.085,0,0,0-.031-.039l-.047-.023h0a.064.064,0,0,0-.023-.039l-.039-.039A.122.122,0,0,0,12-11.164l-.016-.008a.032.032,0,0,1-.023-.008.032.032,0,0,0-.023-.008.069.069,0,0,1-.031-.008l-.016-.008a.069.069,0,0,1-.031-.008.069.069,0,0,0-.031-.008.129.129,0,0,1-.039-.008.173.173,0,0,0-.055-.008H5.641a.487.487,0,0,0-.359.141.487.487,0,0,0-.141.359.487.487,0,0,0,.141.359.487.487,0,0,0,.359.141h4.891L3.922-3.609a.453.453,0,0,0-.156.352.408.408,0,0,0,.156.336.388.388,0,0,0,.156.117.484.484,0,0,0,.188.039A.484.484,0,0,0,4.453-2.8a.388.388,0,0,0,.156-.117l6.625-6.609v4.891a.487.487,0,0,0,.141.359.487.487,0,0,0,.359.141.487.487,0,0,0,.359-.141.487.487,0,0,0,.141-.359v-6.187Z"
          transform="translate(11314.293 11849.606) rotate(-45)"
          fill="#4ba345"
          stroke="#4ba345"
          strokeWidth="1"
        />
      </G>
    </Svg>
  )
}
